// extracted by mini-css-extract-plugin
module.exports = {"main":"nav-module--main--1KbVS","name":"nav-module--name--1bAk4","active":"nav-module--active--6ADdk","circle":"nav-module--circle--5Qk_I"};